let result;

export const getNewsletterWidget = () => {
  if (result) return Promise.resolve(result);
  return import('./widget-newsletter').then((module) => {
    result = module;
    return module;
  });
};
